import { entity } from '@talisdev/jsonapi-transformers';

import { HierarchyNode } from './hierarchy-node';

@entity({ type: 'divisions' })
export class Division extends HierarchyNode {}
